export const ORDER_DIRECTION = {
  ASC: 'asc',
  DESC: 'desc',
} as const;
